<div class="menu">
    <button class="btn btn--clear btn--mobile-menu" (click)="openMenu()">
      <!-- OK -->
      <app-icon
        icon="menu"
        class="icon">
      </app-icon>
    </button>
</div>

<ng-container #sidebarTemplate>
</ng-container>
